module.exports = __webpack_public_path__ + "static/media/Wakefield-whistleblowing-appendix-2-list-prescibed-persons-1.c06c9b58.pdf";